import { Box, Grid, Typography } from "@mui/material";
import { useUserData } from "../../user";
import { categoryLabel, categoryOf } from "../../utils/entity/categories";
import CustomButton from "../global/CustomButton";
import CustomCard from "../global/CustomCard";

const Row = ({ label, children }) => (
  <>
    <Grid item xs={6} alignItems={"center"}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
        }}
      >
        {label}
      </Typography>
    </Grid>
    <Grid item xs={6}>
      {children}
    </Grid>
  </>
);

const WalletDetails = ({ entity, onEdit }) => {
  const userData = useUserData();

  return (
    <Grid container spacing={3}>
      {/* GENERAL CARD */}

      <Grid item xs={12} md={6} lg={4}>
        <CustomCard
          cardHeader={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              General
              {userData?.isAdmin && onEdit && (
                <CustomButton
                  type={"edit"}
                  buttonText={"Edit"}
                  onClick={onEdit}
                  sx={{
                    borderRadius: "4px",
                    px: 0.5,
                    py: 0.2,
                    fontSize: "0.675rem",
                    height: "24px",
                  }}
                />
              )}
            </Box>
          }
        >
          <Grid container rowSpacing={0.5}>
            <Row label="Category">{categoryLabel(categoryOf(entity))}</Row>
            <Row label="Native assets">
              {entity?.hasNativeAssets ? "Yes" : "No"}
            </Row>
            <Row label="Staking">{entity?.hasStaking ? "Yes" : "No"}</Row>
          </Grid>
        </CustomCard>
      </Grid>
    </Grid>
  );
};

export default WalletDetails;
